"use client";

import { useEffect, useState } from "react";
import { Icon } from "../_family/Icon";

/** Copies the hero's door line, and says so for a moment. */
export function CopyLine({ text, label }: { text: string; label: string }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 1600);
    return () => clearTimeout(t);
  }, [copied]);

  return (
    <button
      className={copied ? "copy did" : "copy"}
      type="button"
      aria-label={label}
      onClick={() => {
        void navigator.clipboard
          ?.writeText(text)
          .catch(() => {})
          .finally(() => setCopied(true));
      }}
    >
      <Icon name={copied ? "check" : "copy"} />
      <span aria-hidden="true">{copied ? "Copied" : "Copy"}</span>
    </button>
  );
}
